"use client";

import { useEffect } from "react";
import Link from "next/link";
import Discord from "@/components/icons/discord";

export default function NotFound() {
  useEffect(() => {
    const container = document.getElementById("preloader");

    if (container && !container.dataset.lottieLoaded) {
      bodymovin.loadAnimation({
        container,
        render: "svg",
        loop: true,
        autoplay: true,
        path: "/preloader/explorer.json",
      });
      container.dataset.lottieLoaded = "true";
    }
  }, []);

  return (
    <div className="flex h-[calc(100vh-16px)] flex-col items-center justify-center p-6 text-center">
      <div className="mx-auto flex max-w-4xl flex-1 items-center justify-center">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          <div className="max-w-xl text-left">
            <h1 className="mb-4 font-headline text-4xl font-semibold text-foreground">
              Lost in the snow?
            </h1>
            <p className="mb-6 font-display text-lg text-foreground">
              That&apos;s okay, friend. At least the Explorer Dude is here to
              keep you company. Go ahead and give him a wave. Did you do it?
              Good now he&apos;s happy - here are a couple of working links so
              you can be happy too:
            </p>

            <nav className="flex flex-col gap-2 font-display text-xl font-bold text-foreground">
              <Link
                href="/settings/profile"
                className="flex items-center gap-2 hover:text-brand-primary"
                target="_blank"
              >
                <Discord className="mt-0.5 size-6 fill-foreground" />
                Join the Libum Community
              </Link>
              <Link
                href="/poweron-pro/users"
                className="hover:text-brand-primary"
              >
                Go Home
              </Link>
            </nav>
          </div>

          <div className="relative flex h-[300px] w-[300px] flex-shrink-0 items-center justify-center">
            <div className="w-full">
              <div
                id="preloader"
                className="w-[300px]"
                data-testid="preloader"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
